// Normally, any references of process.env.REACT_APP_[VARIABLE_NAME] are replaced
// at build time, however this means we need to create a separate image for each
// environment.
// The following is a workaround implementation which injects the config
// based on the config present in the environment inside the docker image
const config: {[key: string]: string | undefined} = (window as any)?.APP_CONFIG ?? {};

const mergedConfig = {
  REACT_APP_ENV: config.REACT_APP_ENV ?? process.env.REACT_APP_ENV ?? process.env.NODE_ENV,

  // IDPs need to be provided as a comma separated list
  ALLOWED_IDPS: (
      config.REACT_APP_ALLOWED_IDPS ??
      process.env.REACT_APP_ALLOWED_IDPS ??
      ''
  )
      .split(',')
      .map(e => e.trim())
      .filter(Boolean),

  API_BASE_URL:
    config.REACT_APP_MOOC_API_ENDPOINT ??
    process.env.REACT_APP_MOOC_API_ENDPOINT,
  API_TIMEOUT: parseInt(
    config.REACT_APP_API_TIMEOUT ?? process.env.REACT_APP_API_TIMEOUT ?? "10000"
  ),

  AUTH_ENDPOINT:
    config.REACT_APP_AUTH_ENDPOINT ?? process.env.REACT_APP_AUTH_ENDPOINT,
  AUTH_REALM:
    config.REACT_APP_AUTH_REALM ?? process.env.REACT_APP_AUTH_REALM,
  AUTH_CLIENT_ID:
    config.REACT_APP_AUTH_CLIENT_ID ?? process.env.REACT_APP_AUTH_CLIENT_ID,

  QUERY_STALE_TIME: parseInt(
    config.REACT_APP_QUERY_STALE_TIME ?? process.env.REACT_APP_QUERY_STALE_TIME ?? "60000"
  ),

  SENTRY_DSN: config.REACT_APP_SENTRY_DSN ?? process.env.REACT_APP_SENTRY_DSN,
  // This should be updated at build time only
  REACT_APP_SENTRY_RELEASE: process.env.REACT_APP_SENTRY_RELEASE,
}

export default mergedConfig
